export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS_ADMIN

export const EP_GET_SUBSCRIPTION_LIST		=		'/api/ikf/subscription/list'
export const EP_GET_SUBSCRIPTION_DETAIL		=		'/api/ikf/subscription/details'


export const EP_KYC_UPLOAD_DOCUMENT = '/api/cvlkra/panUpload'
export const EP_KYC_USER_LISTING = '/api/cvlkra/panList'

export const EP_GET_USER_PAN_ATTEMPT_LIST = '/api/pancard/userList'
export const EP_UPDATE_USER_PAN_ATTEMPTS = '/api/pancard/allowed'

export const EP_GET_ADMIN_CHART_DATA = '/api/stat/dashboard/statistics'

export const EP_GET_API_KEY_LIST = '/get/api/key/list'


export const EP_LEAD_USER_LISTING = '/api/get/lead/regis/list'

export const EP_DISABLE_API_KEY = ''

export const EP_USER_OTP_CHECK  = '/api/not/register/lead'
export const EP_DETAIL_USER_PAN_ATTEMPTS  = '/api/pancard/userDetails'

export const EP_CREATE_TICKET = '/api/create/ticket'

export const EP_TRANSFER_DATA_TO_SQUADIQ = '/api/transfer/user/to/squadiq'
export const EP_USER_LIST_FOR_SQUADIQ  = '/api/list/squadiq/user'
export const EP_REMOVE_USER_FROM_HOLD_STAGE = '/api/remove/user/from/hold'

export const EP_SET_CVL_RESPONSE = '/get/cvl/response'

export const EP_GET_CVL_DATA_API = '/api/cvsl/insert/update/kyc/record'

export const EP_GET_CVL_STATUS = '/api/get/cvl/status'

export const EP_USER_UPDATE_FOR_SQUADIQ = '/api/update/lead/squadiq1'

export const EP_DOWNLOAD_PAYMENT_SHEET = '/api/upi/virtual/trans/list'

export const EP_GET_BANK_DETAIL_SHEET = '/api/get/bank/detail/sheet'

export const EP_USER_XML_DOWNLOAD = '/api/user/xml/download'


export const EP_BACKSTAGE_TICKET = '/api/backstage/ticket'
//------------------------------------------------------Add API---------------------------------------------------------------
export const EP_ADD_SUPPORT_DATA = '/api/create/ticket'
export const EP_REPLY_SUPPORT_DATA = '/api/create/ticket/thread'
export const EP_ADD_ESIGN_ADHAR_DATA = '/api/esign/ticket/request'
export const EP_ADD_PAYIN_DATA = '/api/service/payment'
export const EP_ADD_COMPLAINT_DATA = '/api/service/otp/request'
export const EP_ADMIN_COMPRESS_PDF = '/api/user/pdf/compress'


export const EP_MARGIN_PLEDGE_ISIN_DOC = '/api/upload/margin-pledge/isin'
//------------------------------------------------------Add OTP --------------------------------------------------------------
//export const EP_ADD_POA_BRACKET_REQUEST_DATA = '/api/service/request/poa/bracket'
export const EP_ADD_SERVICE_REQUEST_CHANGE_DATA = '/api/service/request'
export const EP_CREATE_USER_SQUADIQ = '/api/create/user/squadiq'
//------------------------------------------------------List API--------------------------------------------------------------
export const EP_GET_POSITION_HOLDING_ORDER_LISTING = '/get/data'
export const EP_GET_SUPPORT_LISTING = '/api/list/tickets'
export const EP_DOWNLOAD_ASBA = '/api/download-asba-report'
export const EP_DOWNLOAD_CONSENT = '/api/service/user/consent/download/data'
export const EP_GET_PROFILE_LISTING = '/api/get/profile'
export const EP_GET_DEPOSIT_LISTING = '/api/list/deposits'
export const EP_GET_FINANCIAL_LEDGER_LISTING = '/api/get/financial/ledger'
export const EP_GET_TAX_REPORT_LISTING = '/api/get/tax/report'
export const EP_GET_CONTRACT_NOTE_LISTING = '/api/contract/notes'
export const EP_GET_TRADE_CONFIRMATION_LISTING = '/api/trade/confirmation'
export const EP_GET_CLOSE_POSITION_LISTING = '/api/get/closed/positions'
export const EP_DISABLE_SEGMENT = '/admin/deactivate/segment/all'
export const EP_GET_PAN_DATA = '/api/pancard/service'
//------------------------------------------------------View API--------------------------------------------------------------
export const EP_VIEW_SUPPORT_DETAIL = '/api/view/tickets'
//--------------------------------------------------dropdown------------------------------------------------------------------
export const EP_GET_SUPPORT_REASON_LISTING = '/api/ticket/reasons'

export const EP_ADMIN_APPROVE_TICKET = '/admin/ticket/approve'

export const EP_ADMIN_APPROVE_TICKET_STEP2 = '/admin/ticket/approve/step2'

export const EP_ADMIN_APPROVE_HV_REACTIVATION_TICKET = '/api/v2/reactivation-account/approve-ticket'
export const EP_ADMIN_PUSH_TO_KORP_HV_REACTIVATION_TICKET = '/api/v2/reactivation-account/pushkorp'

export const EP_ADMIN_ACCEPT_REJECT_TICKET = '/admin/ticket/reject'

export const EP_ADMIN_USER_LISTING = '/admin/user/listing'
export const EP_ADMIN_USER_LISTING_ALL = '/api/admin/all/user/listing'
export const EP_VIEW_ADMIN_USER_DETAIL = '/admin/user/view/detail'
export const PAN_NUMBER_LISTING = '/api/pancard-fetch-list'//PANNUMBER-SEARCH
export const PAN_FETCH_DIGITAP = '/api/digitap/pan_details'//PANNUMBER-Digitap-fetch


// CVL Reporting
export const EP_CVL_STATUS_LISTING = '/api/get/cvl/status/list'
export const EP_CVL_RESPONSE_LISTING = '/api/get/cvl/response/status/list'

//Push to FTP
export const EP_PUSH_TO_FTP = '/api/send/cvl/document/ftp'


export const EP_ADMIN_ACCEPT_REJECT_DOCUMENT = '/admin/user/check'
export const EP_ADMIN_ACCEPT_USER = '/admin/approve/user'
export const EP_ADMIN_HOLD_USER = '/admin/reject/user'
export const EP_ACCEPT_USER_KYC = '/admin/approve/kyc'
export const EP_DASHBOARD_API = '/api/dashboard'

export const EP_ACCEPT_USER_KYC_MANUALLY = '/admin/approve/kyc/manual'
export const EP_TICKET_STATUS_FUNCTION = '/admin/change/ticket/status'
export const EP_RESIGN_DOCUMENT = '/admin/ticket/enable/resign'
export const EP_RESIGN_USER_KYC = '/admin/enable/user/resign'
export const EP_GET_RISING_UPDATE_SYNCED = '/list/rising/update/sync'
export const EP_MISSING_TICKET = '/admin/ticket/missing/pic'
export const EP_GET_LIST_USER_SYNCED = '/list/users/need/sync'
export const EP_PAN_API = '/admin/is/pan'
export const EP_CHANGE_USER_STEP = '/admin/change/user/step'
export const EP_USER_VERIFY_FINAL = '/admin/complete/user/registeration'
export const EP_SWITCH_NON_KRA = '/admin/change/kra/status'
export const EP_CLIENT_INFO_EDIT = '/admin/update/user'
export const EP_RM_UPLOAD_DOCUMENT = '/rm/upload/user/docs'
export const EP_RM_VERIFY_USER = '/admin/user/approve/sales'
export const EP_RM_ADD_COMMENT = '/user/internal/comment'
export const EP_CATEGORISATION_USER = '/admin/categorisation/list'
export const EP_CATEGORISATION_USER_DETAIL = '/admin/categorisation/details'
export const EP_DEMAT_PENDING_LIST = '/admin/user/demat/listing'
export const EP_ADMIN_ASSIGN_TICKET = '/admin/assign/ticket'
export const EP_EDIT_PROFILE_IMAGE = '/api/add/profile/image'
export const EP_RESET_QUESTION_ANSWER = '/api/reset/2fa'
export const EP_RESET_PASSWORD = '/api/back/reset/password'
export const EP_CHANGE_NEST_USER = '/api/change/nest/user'
export const EP_ADD_DEMAT_DETAILS = '/api/change/demat/details'
export const EP_FETCH_KRA_KYC = '/api/get/client/files'
export const EP_EXCHANGE_DATA = '/admin/categorisation/download'
export const EP_LIST_USER_RISING_SYNC = '/list/users/need/rising/sync'
export const EP_LIST_USER_RISING_SYNC_NON_KRA = '/admin/kraxml/download'
export const EP_STEP_SKIP_API = '/user/skip/documentation'
export const EP_IS_USER_VERIFY = '/api/clients/all/docs/approved'
export const EP_OPEN_CASH   = '/api/open/cash/flag'
export const EP_REJECT_USER_DOCS = '/api/reject/user/docs/ticket'
export const EP_USER_UPDATE_CLIENT_CODE = '/api/user/update/client/code'
export const EP_ADMIN_PAYIN = '/api/user/payin'
export const EP_ADMIN_PAYOUT = '/api/user/payout'
export const EP_ADMIN_PAYOUT_LIST = '/api/service/payout/ticket/list'
export const EP_UPLOAD_PAYOUT = '/api/user/payout/upload'
export const EP_UPLOAD_ATOM_TXN_PAYIN = '/api/user/payin/upload'

export const EP_UPLOAD_MF_ISIN_DOC = '/api/upload/mf/isin'
export const EP_STAGGING_RISING_LIST = '/api/service/payout/error/ticket/list'
export const EP_STAGGING_RISING_UPDATE = '/api/payout/error/list/update'
export const EP_ATOM_CREDIT_PAYMENT = '/api/atom/debits'
export const EP_ENABLE_ESIGN_DOC = '/api/update/esign/status'
export const EP_ADD_EDIT_TICKET = '/api/update/user/address'
export const EP_UPLOAD_DOCUMENT = '/api/rising/users/upload'
export const EP_UPLOAD_CVL_DOCUMENT = '/api/kra/verify-status'


export const EP_LOCK_UNLOCK_TRANSACTION = '/api/set/transaction/status'
export const EP_GET_LOCK_UNLOCK_DATA = '/api/get/transaction/status'
export const EP_RISING_RECONCILATION_LIST = ''
export const EP_DEBIT_LIST = '/unproven/payin/list'
export const EP_ADD_CLIENT_CODE_DEBIT_LIST = '/approve/payin/transaction'
export const EP_CANCEL_PAYOUT = '/cancel/payout'



export const EP_GET_CAT_LIST = '/api/blog/category/list'
export const EP_CREATE_CATEGORY = '/api/blog/add/edit/categories'
export const EP_CREATE_ARTICLE = '/api/blog/add/edit/article'
export const EP_GET_ARTICLE_LIST 	= 	'/api/blog/article/list'
export const EP_GET_ARTICLE_DETAIL = '/api/blog/article/details'
export const EP_GET_CAT_DETAIL 		= 	'/api/blog/category/details'

export const EP_CHANGE_PASSWORD 		= 	'/change/password'

export const EP_GET_COUPON_LISTING		=		'/api/admins/referral/users'
export const EP_COUPON_DOCUMENT			=		''
export const EP_COUPON_CSV_FILE			=		'/api/admins/processed/request'

// -------------------------create admin-----------------------------------------
export const EP_CREATE_ADMIN			=		'/api/create/admin'
export const EP_COUPON_EMAIL_SENT		=		'/api/admins/mf/orderplaced'

//--------------------------nominee data--------------------------------------

export const EP_GET_USERS_LIST_FOR_NOMINEE			=		'/api/get/nominee/sheet/data'

export const EP_GET_NOMINEE_DETAIL					=		'/api/get/nominee/info'

export const EP_GET_ADMIN_REFERRED_LIST			=		'/api/user/referred/list'

export const EP_UPLOAD_ACCOUNT_PAYOUT   	= 			'/api/user/sheet/upload'

export const EP_UPLOAD_ACCOUNT_STATUS_DOC = '/api/user/account/status/sheet/upload'
export const EP_DOWNLOAD_EXCEL_SHEET_USER_DETAIL   	= 			'/api/download/excel/sheet/user/detail'

//--------------------------splitter tool--------------------------------------

export const EP_SPLITTER_TOOL_UPLOAD   	= 			'/api/user/splitter/upload'
export const EP_SPLITTER_LIST   	= 			'/api/user/splitter/list'
export const EP_SPLITTER_CANCEL   	= 			'/api/cancel/splitter/files'
export const EP_SPLITTER_DELETE   	= 			'/api/delete/splitter/files'




// WEBPACK FOOTER //
// ./src/store/api/prism_admin/endpoints.js